import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { HelperFormModule } from '@core/components/helpers/form/form.module';
import { LayoutModule } from '@core/components/layout/layout.module';
import { ShareModule } from '@app/components/share/share.module';
import { HelperNavigationModule } from '@core/components/helpers/navigation/navigation.module';
import { CoreProjectsModule } from '@core/components/projects/projects.module';
import { PluginShareTransferMainAppComponent } from './main/main.component';
import { ShareTransferSectionsModule } from './sections/sections.module';
@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        HelperBoxModule,
        HelperFormModule,
        HelperNavigationModule,
        LayoutModule,
        ShareModule,
        CoreProjectsModule,
        ShareTransferSectionsModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        PluginShareTransferMainAppComponent
    ],
    exports: [
        PluginShareTransferMainAppComponent,
        ShareTransferSectionsModule
    ],

})
export class ShareTransferAppComponentsModule { }
